// src/lib/utils.js
export const cn = (...classes) => classes.filter(Boolean).join(" ");
